<template lang="pug">
.report-root
    general-title(
        title="实时数据",
        description="提供网站实时的流量数据，通过流量的趋势变化，来分析出网站访客的访问规律、网站发展状况等",
        pos="right"
    )

    TopStatis(:data="topStatisData")

    .zone
        TableTitle(icon="fa fa-signal", title="趋势图")
            div.realtime-uv 当前在线人数 {{realTimeUV}}
        div.header-chart-line
        div.toggle-flow-type
            span.checkbox(:class="{checked: flowChartType === 'pv'}", @click="changeFlowType('pv')")
                | 浏览量(PV)
            span.checkbox(:class="{checked: flowChartType === 'uv'}", @click="changeFlowType('uv')")
                | 访客数(UV)
        LineChart(
            :legend="flowChartLegend",
            :xAxis="flowChartXAxis",
            :series="flowChartSeries",
        )

    .zone
        TableTitle(icon="fa fa-list", title="实时访客报表")
            small.table-title-tip （实时数据用于实时查看网站访问明细，不作为推广点击扣费及反作弊数据源，360推广消费数据请以点睛后台数据为准）
            div.download-btn(v-show="visitorList.length")
                DownloadBtn(
                    reportApi="/api/realtime/top",
                    pagetitle="实时访客报表",
                    :params="downloadParams"
                )
        div.header-chart-line
        div.table-tool-row
            | 访问来源：
            v-select(
              v-model="filterParams.refertype",
              :options="refertypeOptions",
              @input="getVisitorList"
              )
            
            | 访问设备：
            v-select(
              v-model="filterParams.device",
              @input="getVisitorList",
              :options="deviceOptions"
              )
            
            | 访问地域：
            v-select(
              v-model="filterParams.region",
              @input="getVisitorList",
              :options="regionOptions"
              )
            
            
            .realtime-search.pull-right
                input(
                    placeholder="搜索词",
                    v-model="filterParams.keyword"
                )
                button.btn.btn-primary.btn-small(@click="getVisitorList") 搜索
        
        table.data-table
            thead
                tr
                    th(width="50") 序号
                    th(width="20%") 访客ID
                    th(width="10%") 访客IP
                    th(width="10%") 访问时间
                        span.sort_icon.margin_icon 
                            i.sort.sort-asc(
                                @click="visitorListSort('asc')",
                                :class="{sorted: listOrder === 'asc'}"
                            ) 
                            i.sort.sort-desc(
                                @click="visitorListSort('desc')",
                                :class="{sorted: listOrder === 'desc'}"
                            ) 
                    th(width="8%") 地域
                    th(width="8%") 搜索词
                    th(width="20%") 来源
                    th(width="20%") 入口页面
            tbody
                tr(
                    v-for="(visitor, index) in currentPageList",
                    v-show="!isListLoading && visitorList.length"
                )
                    td {{index + 1}}
                    td {{visitor.guid}}
                    td {{visitor.ip}}
                    td {{visitor.vtime}}
                    td {{visitor.province}}
                    td {{visitor.keyword || '--'}}
                    td
                        span(:title="visitor.refer")
                            | {{visitor.refer}}
                    td
                        a(
                            :href="visitor.eurl | httpUrl",
                            :title="visitor.eurl | httpUrl",
                            target="_blank"
                        ) {{visitor.eurl}}
                tr(v-show="!isListLoading && visitorList.length === 0")
                    td(colspan="8", style="text-align: center;") 暂无数据
                tr(v-show="isListLoading && visitorList.length === 0")
                    td(colspan="8", style="text-align: center;")
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
        v-pagination(
            :total="visitorList.length",
            :pn="pageNum",
            ps="10",
            @updatepage="onPageChange"
        )

</template>

<script>
import { PROVINCES_OF_CHINA } from './constants';
import { getDateString } from '../../script/util';

const indices = [
    ['pv', '浏览量(PV)'],
    ['uv', '访客数(UV)'],
    ['newvst', '新独立访客'],
    ['vnum', '访问次数'],
    ['anum', '平均访问页数']
];

const makeTimeLegends = function (now) {
    now = now || new Date();
    let timespan = now.getTime(),
        step = 60 * 1000;

    let sixtyItem =  _.map( _.fill(new Array(60), 0), (v, i) => {
        return new Date( timespan - ( 59 - i ) * step );
    });
    
    return _.map( sixtyItem, item => {
        return item.toTimeString().substr(0, 5);
    });
};

const arrToIdVal = (arr) => arr.map((item, i) => {
    return {
        value: i,
        label: item
    };
});

const provinces = ['全国'].concat(PROVINCES_OF_CHINA.slice(0)).map(item => {
  return {
    value: item,
    label: item
  }
});
const initialFilterModel = {
    refertype: 0,
    device: 0,
    region: provinces[0].value,
    keyword: ''
};

export default {
    data() {
        return {
            topStatisData: indices.map(arr => ({ name: arr[1]})),
            flowChartType: 'pv',
            flowListData: [],
            flowChartLegend: ['浏览量(PV)'],
            flowChartSeries: [],
            flowChartXAxis: makeTimeLegends(),

            refertypeOptions: arrToIdVal(['全部','外部链接','搜索引擎','直接访问']),
            deviceOptions: arrToIdVal(['全部','PC','移动']),
            regionOptions: provinces,
            filterParams: _.cloneDeep(initialFilterModel),

            isListLoading: true,
            visitorListOrig: [],
            visitorList: [],
            currentPageList: [],
            listOrder: '',
            pageNum: 1,
        };
    },

    computed: {
        domainId() {
            return this.$store.state.domainId;
        },

        realTimeUV() {
            let list = this.flowListData;
            let len  = list.length;
            let lastOne = list[len - 1];
            let lastTwo = list[len - 2];
            return lastOne && lastOne.uv || lastTwo && lastTwo.uv || 0;
        },

        downloadParams() {
            let params = _.cloneDeep(this.filterParams);
            params.domainId = this.domainId;
            params.start = getDateString(new Date());
            params.end   = params.start;
            return params;
        }
    },
    watch: {
        domainId() {
            // reset filters
            this.filterParams = _.cloneDeep(initialFilterModel);

            this.getRealTimeByDay();
            this.getRealTimeByMin();
            this.getVisitorList();
        }
    },
    methods: {
        changeFlowType(type) {
            this.flowChartType = type;
            this.getRealTimeByMin();
        },

        onPageChange(num) {
            num = num || this.pageNum;
            let startIndex = (num - 1) * 10;
            this.pageNum = num;
            this.currentPageList = this.visitorList.slice(startIndex, startIndex + 10);
        },

        visitorListSort(order) {
            if (this.listOrder === order) return;

            let listDesc = _.cloneDeep(this.visitorListOrig);
            this.listOrder = order;
            this.visitorList = order === 'desc' ?  listDesc : listDesc.reverse();

            this.onPageChange();
        },

        getVisitorList() {
            if (!this.domainId) {
                return;
            };

            this.isListLoading = true;
            this.visitorList = [];

            let params = _.cloneDeep(this.filterParams);
            params.domainId = this.domainId;
            params.start = getDateString(new Date());

            this.$http.get('/api/realtime/top', {
                params
            }).then(res => {
                return res.data.list || [];
            }).then(list => {
                this.visitorListOrig = _.cloneDeep(list);
                this.visitorList = list;
                this.onPageChange(1);
            }).then(() => {
                this.$nextTick(() => {
                    this.isListLoading = false;
                });
            });
        },

        getRealTime(cycle) {
            if (!this.domainId) return Promise.resolve({});

            return this.$http.get('/api/realtime/list', {
                params: {
                    domainId: this.domainId,
                    cycle
                }
            }).then((r) => {
                return r.data || {};
            }).catch(() => {
                return {};
            });
        },

        getRealTimeByDay() {
            this.getRealTime('day').then(data => {
                if (data.errno === 0) {
                    let obj = data.list[0] || {};

                    this.topStatisData = indices.map(arr => ({
                        name: arr[1],
                        value: obj[arr[0]]
                    }));
                } else {
                    data.errmsg && this.$Modal.warn(data.errmsg);
                }
            });
        },

        getRealTimeByMin() {
            this.$store.dispatch("SET_CHART_LOADING", true);
            this.getRealTime('min').then(data => {
                if (data.errno !== 0) {
                    data.errmsg && this.$Modal.warn(data.errmsg);
                    return;
                }
    
                let flowDataMap = data.list.reduce((accu, item) => {
                    let { min } = item;
                    accu[min] = item;
                    return accu;
                }, {});

                this.flowChartXAxis = makeTimeLegends();
                this.flowListData = this.flowChartXAxis.map(
                    min => flowDataMap[min] || { pv: 0, uv: 0 }
                );

                let legend = this.flowChartType === 'pv' ? '浏览量(PV)' : '访客数(UV)';
                this.flowChartLegend = [...legend]
                this.flowChartSeries = [
                  {
                    name: legend,
                    data: this.flowListData.map(item => item[this.flowChartType])
                  }
                ]

                this.$store.dispatch("SET_CHART_LOADING", false);
            });
        }
    },
    created() {
        this.getRealTimeByDay();
        this.getRealTimeByMin();
        this.getVisitorList();
    }
};
</script>

<style scoped>
.charts {
  border: 0!important;
}
.zone {
    background: #fff;
    margin: 20px 0;
}
.realtime-uv {
    float: right;
    margin-right: 30px;
    font-size: 12px;
    color: #999;
}

.toggle-flow-type {
    padding: 5px 0 10px 3em;
    -webkit-user-select: none;
            user-select: none;
}

.checkbox {
    display: inline-block;
    padding-left: 20px;
    margin-right: 25px;
    font-size: 12px;
    cursor: pointer;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEX////d4Ord4Ofd3+va4eje4OV0/av1AAAAO0lEQVQI12NwVTI2ElJScmUIYAADJgYFNAYLgwGEwQhjMCEYDjApAQyGApyBLgXXhTA5SEVIUVBQUBQAg8wErikP7a8AAAAASUVORK5CYII=) left center no-repeat;
}

.checkbox.checked {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAe1BMVEX//////v////39///c4Ond4ef+/v3e4OUnvE7d4OsovEwqvVDb4OnZ4Oip5Lj7/fr2/ffc3uri9ufA68pv04xOym1BxmQ7wV0uwFYlvEzw+vLs+fDp9u3c89/W893Q8NnN79ae4LCS3aWH2J131Ytr0Ydeznxhzns2wVy3gNuAAAAAsklEQVQY0y2PV3IEMQhEm0YgjSZsTs7Zvv8J3VO1/Kh4rUcB5hoxDLsotUTEVFENKrqBgHlFIAXS9BjBQIinSDoV+IRBDZnm2B4XWlkBqMgefsbbh4QdEyn2dGptXDwww/YH2vO5tesBLsVfLuPy9tf65RXrjMLv3m/X1s97M0NBYHMce2+nRybdBIz+ObbfrWJHSgHg71+bdHdAP2YDSHV0KVwXS4ciQgkk1BqTDi/3qv+EGQbH70lusQAAAABJRU5ErkJggg==);
}

.table-title-tip {
    font-size: 12px;
    color: rgb(210, 176, 37);
    margin-left: 5px;
}

.table-tool-row {
    padding: 0 20px 20px;
    font-size: 12px;

    & > select {
        width: 8em;
        margin: 0 15px 0 5px;
    }
}

.data-table {
    table-layout: fixed;
    th span.margin_icon {
        margin-left: 6px;
    }
}
.data-table th,
.data-table td {
    text-align: left;
}
.data-table th:first-child,
.data-table td:first-child {
    text-align: center;
}
.download-btn{
    float: right;
    margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// realtime.vue?42bb4511